import * as React from "react";
const SvgDelivery = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 32 32", id: "svg5", xmlns: "http://www.w3.org/2000/svg", "xmlns:svg": "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("defs", { id: "defs2" }), /* @__PURE__ */ React.createElement("g", { id: "layer1", transform: "translate(36.000001,-436)" }, /* @__PURE__ */ React.createElement("path", { d: "m -28,456.01367 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z", id: "path453669", style: {
  color: "#000000",
  fill: "#000000",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4.1,
  InkscapeStroke: "none"
} }), /* @__PURE__ */ React.createElement("path", { d: "m -26,453.01367 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 6 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z", id: "path453653", style: {
  color: "#000000",
  fill: "#000000",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4.1,
  InkscapeStroke: "none"
} }), /* @__PURE__ */ React.createElement("path", { d: "m -23,450.01367 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 3 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z", id: "path453635", style: {
  color: "#000000",
  fill: "#000000",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4.1,
  InkscapeStroke: "none"
} }), /* @__PURE__ */ React.createElement("path", { d: "m -29,443.01367 a 1,1 0 0 0 -1,1 v 1 h -1 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 1 v 1 a 1,1 0 0 0 1,1 1,1 0 0 0 1,-1 v -1 h 1 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 h -1 v -1 a 1,1 0 0 0 -1,-1 z", id: "path453629", style: {
  color: "#000000",
  fill: "#000000",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4.1,
  InkscapeStroke: "none"
} }), /* @__PURE__ */ React.createElement("path", { d: "m -29,440.01367 c -3.301857,0 -6.000001,2.69815 -6,6 -10e-7,1.76801 0.774349,3.36262 2,4.46289 v 11.53711 a 1.0001,1.0001 0 0 0 1,1 h 2.173828 c 0.415693,1.16039 1.530816,2 2.826172,2 1.295356,0 2.410479,-0.83961 2.826172,-2 H -17 h 2.173828 c 0.415693,1.16039 1.530816,2 2.826172,2 1.295356,0 2.4104792,-0.83961 2.8261719,-2 H -6 a 1.0001,1.0001 0 0 0 1,-1 v -7 a 1.0001,1.0001 0 0 0 -0.21875,-0.625 l -4,-5 A 1.0001,1.0001 0 0 0 -10,449.01367 h -6 v -2 a 1.0001,1.0001 0 0 0 -1,-1 h -6 c 1e-6,-3.30185 -2.698143,-6 -6,-6 z m 0,2 c 2.220979,0 4,1.77902 4,4 0,2.22098 -1.779021,4 -4,4 -0.84757,0 -1.630859,-0.25926 -2.275391,-0.70312 a 1,1 0 0 0 -0.267578,-0.20117 C -32.434453,448.37778 -33,447.26595 -33,446.01367 c 0,-2.22098 1.779021,-4 4,-4 z m 5.654297,6 H -18 v 13 h -6.173828 c -0.415693,-1.16039 -1.530816,-2 -2.826172,-2 -1.295356,0 -2.410479,0.83961 -2.826172,2 H -31 v -9.3457 c 0.626269,0.22297 1.29935,0.3457 2,0.3457 2.601207,0 4.826496,-1.67494 5.654297,-4 z m 7.345703,3 h 2 v 5 a 1.0001,1.0001 0 0 0 1,1 h 6 v 4 h -2.1738281 c -0.4156927,-1.16039 -1.5308159,-2 -2.8261719,-2 -1.295356,0 -2.410479,0.83961 -2.826172,2 H -16 Z m 4,0 h 1.519531 l 3.199219,4 H -12 Z m -15,10 c 0.564128,0 1,0.43587 1,1 0,0.56413 -0.435872,1 -1,1 -0.564128,0 -1,-0.43587 -1,-1 0,-0.56413 0.435872,-1 1,-1 z m 15,0 c 0.564128,0 1,0.43587 1,1 0,0.56413 -0.435872,1 -1,1 -0.564128,0 -1,-0.43587 -1,-1 0,-0.56413 0.435872,-1 1,-1 z", id: "path453611", style: {
  color: "#000000",
  fill: "#000000",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4.1,
  InkscapeStroke: "none"
} })));
export default SvgDelivery;
